/**
 * 导航顶部产品条：竖向滚轮转为横向滚动（仅当条可横向滚动时拦截默认滚动）
 */
(function () {
  if (window.__t4sNavPrStripWheel) return;
  window.__t4sNavPrStripWheel = true;

  document.addEventListener(
    'wheel',
    function (e) {
      var el = e.target.closest('[data-t4s-nav-pr-scroll]');
      if (!el) return;
      if (el.scrollWidth <= el.clientWidth + 1) return;

      var dx = e.deltaX;
      var dy = e.deltaY;
      if (Math.abs(dy) <= Math.abs(dx)) return;

      var step = dy;
      if (e.deltaMode === 1) step *= 16;
      else if (e.deltaMode === 2) step *= el.clientHeight;

      var next = el.scrollLeft + step;
      if (next < 0) next = 0;
      if (next > el.scrollWidth - el.clientWidth) next = el.scrollWidth - el.clientWidth;

      if (next !== el.scrollLeft) {
        e.preventDefault();
        el.scrollLeft = next;
      }
    },
    { passive: false, capture: true }
  );

  /** Mega：lkcol 悬停集合链接时，下方预览区切换为该集合产品 */
  var __t4sMegaPrevKey = '';
  function t4sMegaPreviewFromLink(a) {
    if (!a || !a.getAttribute('data-t4s-col-preview')) return;
    var wrap = a.closest('[data-t4s-mega-preview-block]');
    if (!wrap) return;
    var bid = wrap.getAttribute('data-t4s-mega-preview-block');
    var h = a.getAttribute('data-t4s-col-preview');
    if (!bid || !h) return;
    var key = bid + ':' + h;
    if (key === __t4sMegaPrevKey) return;
    __t4sMegaPrevKey = key;
    var pool = document.getElementById('mega_preview_pool_' + bid);
    var host = document.getElementById('mega_preview_host_' + bid);
    if (!pool || !host) return;
    var esc =
      typeof CSS !== 'undefined' && typeof CSS.escape === 'function'
        ? CSS.escape(h)
        : String(h).replace(/\\/g, '\\\\').replace(/"/g, '\\"');
    var chunk = pool.querySelector('[data-preview-handle="' + esc + '"]');
    if (!chunk) return;
    host.innerHTML = chunk.innerHTML;
  }
  document.addEventListener(
    'mouseover',
    function (e) {
      var a = e.target.closest('a.t4s-lkcol__link[data-t4s-col-preview]');
      if (a) t4sMegaPreviewFromLink(a);
    },
    true
  );
  document.addEventListener(
    'focusin',
    function (e) {
      var a = e.target.closest('a.t4s-lkcol__link[data-t4s-col-preview]');
      if (a) t4sMegaPreviewFromLink(a);
    },
    true
  );
})();
